enum TranslationArea {
	Casino = 1,
	Gamification = 2,
	Trading = 3,
	Archived = 4,
	Affiliation = 5,
	RetentionGames = 6,
	AffIliateAdminNew = 7,
	Academy = 8,
}

export { TranslationArea };
